/**
 * Main JS
 */

(function($) {

  let isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  let global_markers = [];
  let global_infowindows = [];

  /**
   * Set the heading height for each column-section column to the max height to get a horizontal layout
   */
  function set_content_cols_alignment () {
    let content_col_section = $('section.columns-section');
    if (!content_col_section.length) {
      return;
    }

    content_col_section.each(function () {

      let $this = $(this),
          cols = $this.find('div.col-item:not(.team-member)');

      if (cols.length) {
        let heading_min_h = 0;
        cols.each(function(){

          let $this_col = $(this),
              heading = $this_col.find('.heading-wrap');

          heading.css('height', 'auto');
          let heading_h = heading.height();
          if (parseInt(heading_h) > heading_min_h) {
            heading_min_h = heading_h;
          }

        });

        cols.find('.heading-wrap').height(heading_min_h);
      }//end if cols len

    });
  }//end set_content_cols_alignment


  /**
   * Align the headings and content within each post
   */
  function align_locations_cols () {

    let section = $('.map-section');
    if (section.length) {

      section.each(function(){
        let $this = $(this),
          cols = $this.find('div.location-col');

        if (cols.length) {
          let heading_min_h = 0;
          cols.each(function(){

            let $this_col = $(this),
                heading = $this_col.find('.heading-wrap');

            heading.css('height', 'auto');
            let heading_h = heading.height();
            if (parseInt(heading_h) > heading_min_h) {
              heading_min_h = heading_h;
            }

          });

          cols.find('.heading-wrap').height(heading_min_h);

        }//end if cols len

      });

    }//end if section len

  }//end align_carousel_posts


  // Close infowindow function
  function closeInfowindows() {
    for (var x = 0; x < global_infowindows.length; x++) {
      global_infowindows[x].close();
    }
  }


  /**
   * initMap
   *
   * Renders a Google Map onto the selected jQuery element
   *
   * @date    22/10/19
   * @since   5.8.6
   *
   * @param   jQuery $el The jQuery element.
   * @return  object The map instance.
   */
  function initMap($el) {

    try {
      // Find marker elements within map.
      let $markers = $el.find('.marker');
      let args = {
        zoom: $el.data('zoom') || 16,
        center: new google.maps.LatLng(0, 0),
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        disableDefaultUI: true,
        mapTypeControl: false,
        styles: [
          {
            "featureType": "administrative",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#232d37"
              }
            ]
          },
          {
            "featureType": "administrative.neighborhood",
            "elementType": "all",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "landscape",
            "elementType": "all",
            "stylers": [
              {
                "color": "#eaeae7"
              }
            ]
          },
          {
            "featureType": "poi",
            "elementType": "all",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "road",
            "elementType": "all",
            "stylers": [
              {
                "saturation": -100
              },
              {
                "lightness": 45
              }
            ]
          },
          {
            "featureType": "road.highway",
            "elementType": "all",
            "stylers": [
              {
                "visibility": "on"
              }
            ]
          },
          {
            "featureType": "road.arterial",
            "elementType": "labels.icon",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "transit",
            "elementType": "all",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "water",
            "elementType": "all",
            "stylers": [
              {
                "color": "#87e2fd"
              },
              {
                "visibility": "on"
              }
            ]
          }
        ]
      };
      let map = new google.maps.Map($el[0], args);

      // Add markers.
      map.markers = [];
      $markers.each(function () {
        initMarker($(this), map);
      });

      // Center map based on markers.
      centerMap(map);

      // Toggles between infowindows
      for (let i = 0; i < global_markers.length; i++) {
        // Keep value of 'i' in event creation
        (function (i) {
          google.maps.event.addListener(global_markers[i], 'click', function () {
            closeInfowindows();
            global_infowindows[i].open(map, global_markers[i]);
          });
        }(i));
      }

      //Show the map
      $el.addClass('map-loaded');

      // Return map instance.
      return map;

    } catch (error) {
      $('div.theme-map-container').hide();
    }
  }

  /**
   * initMarker
   *
   * Creates a marker for the given jQuery element and map.
   *
   * @date    22/10/19
   * @since   5.8.6
   *
   * @param   jQuery $el The jQuery element.
   * @param   object The map instance.
   * @return  object The marker instance.
   */
  function initMarker($marker, map) {

    // Get position from marker.
    var lat = $marker.data('lat');
    var lng = $marker.data('lng');

    var latLng = {
      lat: parseFloat(lat),
      lng: parseFloat(lng)
    };

    // Create marker instance.
    var marker = new google.maps.Marker({
      position: latLng,
      map: map,
      icon: {
        url: $marker.data('pin-icon'),
        scaledSize: new google.maps.Size(35, 35)
      }
    });

    // Append to reference for later use.
    map.markers.push(marker);
    global_markers.push(marker);

    // If marker contains HTML, add it to an infoWindow.
    if ($marker.html()) {
      // Create info window.
      var infowindow = new google.maps.InfoWindow({
        content: '<div class="theme-map-infoWindow">'+$marker.html()+'</div>'
      });

      global_infowindows.push(infowindow);

    }
  }

  /**
   * centerMap
   *
   * Centers the map showing all markers in view.
   *
   * @date    22/10/19
   * @since   5.8.6
   *
   * @param   object The map instance.
   * @return  void
   */
  function centerMap(map) {

    // Create map boundaries from all map markers.
    var bounds = new google.maps.LatLngBounds();
    map.markers.forEach(function (marker) {
      bounds.extend({
        lat: marker.position.lat(),
        lng: marker.position.lng()
      });
    });

    // Case: Single marker.
    if (map.markers.length == 1) {
      map.setCenter(bounds.getCenter());

      // Case: Multiple markers.
    } else {
      map.fitBounds(bounds);
    }
  }


  $(function() {


    //Set content cols alignment
    set_content_cols_alignment();
    align_locations_cols();


    //OnResize
    $(window).on('resize', function () {

      set_content_cols_alignment();
      align_locations_cols();

    });


    //Nav click
    $('button.slide-out-nav-button').click(function(e){

      e.preventDefault();

      let $this = $(this);

      //Show
      if (!$this.hasClass('is-active')) {
        $('body').addClass('menu-active');
        $this.attr('aria-expanded', 'true').addClass('is-active');
      } else {//hide
        $('body').removeClass('menu-active');
        $this.attr('aria-expanded', 'false').removeClass('is-active');
      }

      return false;

    });



    //Page scroll
    $("a.page-scroll").bind("click", function (e) {

      let target = $(this).attr("href");

      //If target is #next get next section after the hero:
      if (target === '#next') {
        target = $('.hero-section').next();
      }

      if (!target.length) {
        return false;
      }

      $("html, body").animate({
        scrollTop: (parseInt($(target).offset().top) - 100)
      }, 700);

      e.preventDefault();

    });


    //Trigger the team member modal:
    $('a.team-member-btn').click(function (e) {

      e.preventDefault();

      //Get the data:
      let $this = $(this),
        bio = $this.data('bio'),
        photo = $this.data('img'),
        name = $this.data('name'),
        role = $this.data('role'),
        img_class = $this.data('img-class');


      $('div#team-modal div.img-wrap').html('<img class="'+img_class+'" src="' + photo + '" alt="' + name + '">');
      $('div#team-modal .team-member-name').text(name);
      $('div#team-modal .team-member-role').text(role);


      //$('div#team-modal div.content-wrap').scrollTop(0);
      $('div#team-modal div.content-outer').html('<div class="content-wrap"><div class="bio">' + bio + '</div></div>');


      imagesLoaded('div#team-modal div.img-wrap img', function () {
        $('button.team-member-button').trigger('click');
      });

      return false;

    });


    //Open / close search
    $('button.search-btn').click(function () {

      const header_search_wrap = $('div#theme-header-search'),
        search_input = $('input#header-search-input'),
        close_btn = $('button.header-search-close'),
        $this = $(this);

      if (header_search_wrap.hasClass('active')) {
        $this.attr('aria-expanded', 'false');
        close_btn.attr('aria-expanded', 'false');
        header_search_wrap.attr('aria-hidden', 'true');

        header_search_wrap.removeClass('visible');
        setTimeout(function () {

          header_search_wrap.removeClass('active');
          setTimeout(function () {
            header_search_wrap.removeClass('show');
            search_input.blur();
          }, 50);

        }, 300);


      } else {
        $this.attr('aria-expanded', 'true');
        close_btn.attr('aria-expanded', 'true');
        header_search_wrap.attr('aria-hidden', 'false');
        header_search_wrap.addClass('show');
        setTimeout(function () {
          header_search_wrap.addClass('active');

          if (!isTouchDevice) {
            search_input.focus();
          }

          setTimeout(function () {
            header_search_wrap.addClass('visible');
          }, 300);
        }, 50);
      }

    });//end open search


    //Close search
    $('button.header-search-close').click(function () {
      const header_search_wrap = $('div#theme-header-search');

      //Make sure the search results are hidden
      $('#header-search-results').removeClass('active');
      $('#header-search-input').attr('aria-expanded', 'false');
      $('input#header-search-input').blur();
      $('button.search-btn').attr('aria-expanded', 'false');
      $(this).attr('aria-expanded', 'false');

      header_search_wrap.removeClass('visible');
      setTimeout(function () {
        header_search_wrap.removeClass('active').attr('aria-hidden', 'true');
        setTimeout(function () {
          header_search_wrap.removeClass('show');
        }, 550);
      }, 300);


    });


    $('.section-collapse.collapse').on('shown.bs.collapse', function(){
      let $this = $(this);
      $this.find('.col-item.col-visibility-hidden').removeClass('col-visibility-hidden').addClass('col-visibility-show');
      set_content_cols_alignment();
    });

    $('.section-collapse.collapse').on('hidden.bs.collapse', function(){
      let $this = $(this);
      $this.find('.col-item.col-visibility-show').removeClass('col-visibility-show').addClass('col-visibility-hidden');
      set_content_cols_alignment();
    });


    //Init maps
    if ($('.theme-map').length) {
       $('.theme-map').each(function () {
        let map = initMap($(this));
      });
    }


    //Map buttons click:
    if ($('button.map-button').length) {
      $('button.map-button').click(function () {
        let $this = $(this);

        if ($this.hasClass('active')) {
          $this.removeClass('active');
          closeInfowindows();
        } else {
          $('button.map-button').removeClass('active');
          $this.addClass('active');
          google.maps.event.trigger(global_markers[$this.data('elem')], 'click');
        }

        // JavaScript for scroll positioning
        const container = document.querySelector('.map-buttons-row');
        const item = this.closest('li');

        container.scrollTo({
          left: item.offsetLeft - container.offsetWidth / 2 + item.offsetWidth / 2,
          behavior: 'smooth'
        });
      });
    }

  });//end DOM loaded


})(jQuery); // Fully reference jQuery after this point.
